var React = require('react');

function Stethoscope (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-stethoscope","d":"M5.56,2a1.28,1.28,0,0,0-1.108.64H4.28A1.29,1.29,0,0,0,3,3.92V7.76a5.129,5.129,0,0,0,3.227,4.753,1.909,1.909,0,0,0,1.252,1.53v.118A3.85,3.85,0,0,0,11.32,18h1.92a3.85,3.85,0,0,0,3.84-3.84V11.489a1.922,1.922,0,1,0-1.28,0V14.16a2.551,2.551,0,0,1-2.56,2.56H11.32a2.551,2.551,0,0,1-2.56-2.56v-.118a1.909,1.909,0,0,0,1.252-1.53A5.129,5.129,0,0,0,13.24,7.76V3.92a1.29,1.29,0,0,0-1.28-1.28h-.174a1.279,1.279,0,1,0,0,1.28h.173V7.76a3.84,3.84,0,1,1-7.68,0V3.92h.174A1.279,1.279,0,1,0,5.56,2Z","transform":"translate(-3 -2)","fill":"#66a9f4"}));
}

Stethoscope.defaultProps = {"width":"15.36","height":"16","viewBox":"0 0 15.36 16"};

module.exports = Stethoscope;

Stethoscope.default = Stethoscope;
